import React, { ReactNode, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import loading from '../lib/loading';
import Layout from '../components/Layout';
import Head from '../components/Head';
import messages from '../lib/messages.json';

const SubscriptionFlowWithLogin = dynamic(
  () => import('../components/SubscriptionFlow/SubscriptionFlowWithLogin'),
  {
    ssr: false,
    loading,
  },
);

const Subscribe = () => {
  const intl = useIntl();
  const { query: { referralCode } } = useRouter();

  useEffect(() => {
    if (typeof referralCode === 'string') {
      localStorage.setItem('referralCode', referralCode);
    }
  }, [referralCode]);

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['subscribe.title'],
        )}
        description={intl.formatMessage(
          messages['subscribe.description'],
        )}
      />
      <SubscriptionFlowWithLogin />
    </>
  );
};

Subscribe.getLayout = (page: ReactNode) => <Layout>{page}</Layout>;

export default Subscribe;
